<div *ngIf="rating; else ratingMuted" class="__rating-bar" [style.width]="width" [style.background-color]="color"></div>
<ng-template #ratingMuted>
    <div class="u-border-radius-filter __rating-bar __rating-bar--muted"></div>
</ng-template>
